

export const ITEMTYPE_LOGIC_FIELD:string = 'logic_field';
export const ITEMTYPE_FIELD:string = 'field';
export const ITEMTYPE_SECTION:string = 'section';
export const ITEMTYPE_PAGE:string = 'page';
